import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GithubRepositoryIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GithubRepository",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.28 5.28c0-.87.35-1.7.96-2.32C6.85 2.35 7.69 2 8.56 2h17.26c.23 0 .46.09.63.26s.26.39.26.63V27.3c0 .24-.09.46-.26.63s-.39.26-.63.26h-7.15c-.24 0-.46-.09-.63-.26s-.26-.39-.26-.63.09-.46.26-.63.39-.26.63-.26h6.25v-4.76H8.85c-.47 0-.93.19-1.26.52-.34.34-.52.79-.52 1.26v.89c0 .85.51 1.59 1.25 1.91.21.1.37.28.45.49.08.22.07.46-.02.67s-.27.38-.48.47-.46.09-.67 0c-.69-.3-1.28-.8-1.69-1.43s-.63-1.37-.63-2.12zm19.64-1.49v16.07H8.85c-.65 0-1.26.17-1.79.48V5.28c0-.82.67-1.49 1.49-1.49zM10.04 23.73q0-.12.09-.21c.09-.09.13-.09.21-.09h5.96q.12 0 .21.09c.09.09.09.13.09.21v5.97s-.02.11-.04.16c-.03.05-.07.08-.12.11-.05.02-.1.04-.16.03a.22.22 0 0 1-.15-.06l-2.63-1.91s-.11-.06-.18-.06-.12.02-.18.06l-2.63 1.91s-.1.05-.15.06c-.05 0-.11 0-.16-.03a.25.25 0 0 1-.12-.11.3.3 0 0 1-.04-.15v-5.97Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m10.42 29.43 3.5-3.51 3.51 3.51v-6.86h-7.01z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.43 30.57c-.3 0-.59-.12-.81-.33l-2.7-2.7-2.7 2.7c-.33.33-.82.42-1.25.25-.43-.18-.71-.59-.71-1.06v-6.86c0-.63.51-1.14 1.14-1.14h7.01c.63 0 1.14.51 1.14 1.14v6.86a1.154 1.154 0 0 1-1.15 1.15Zm-2.68-5.43 1.53 1.53v-2.96h-4.73v2.95l1.49-1.49c.28-.33.72-.47 1.15-.37.22.05.41.17.56.33Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6 26c-.63 0-1.14-.51-1.14-1.14V6.57c0-3.15 2.56-5.71 5.71-5.71h16c.63 0 1.14.51 1.14 1.14v20.57c0 .63-.51 1.14-1.14 1.14h-16a1.14 1.14 0 1 1 0-2.28h14.86V3.14H10.57c-1.89 0-3.43 1.54-3.43 3.43v18.29C7.14 25.49 6.63 26 6 26M26.57 28.28H22A1.14 1.14 0 1 1 22 26h4.57a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
GithubRepositoryIcon.displayName = 'GithubRepositoryIcon';